/*
 * BCS Transform course percentage, shared by the learner store and the Transform Tracker:
 *
 *     percent = round((completed videos + passed quizzes) / (videos + quizzes) * 100)
 *
 * Only a fully finished course reads 100 — rounding caps anything short of it at 99, so
 * "100% = certifiable" holds however many items the course has. Mirrors resolveItemsPercent
 * in functions/src/transformLearning/resolveCourseProgress.js; functions/ and src/ share no
 * module, so keep both in sync.
 */
export function resolveItemsPercent(completedItems, totalItems) {
  if (totalItems <= 0) return 0
  if (completedItems >= totalItems) return 100
  return Math.min(99, Math.round((completedItems / totalItems) * 100))
}
